module.exports = __webpack_public_path__ + "static/img/game12.850ed93.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/game12.jpg
// module id = fETz
// module chunks = 1